require('./bootstrap');
require('./components/links');

import EmblaCarousel from "embla-carousel";

import Accommodation from "./components/accommodation.js"
import { store as ConfirmStore, customConfirm} from "./components/confirm-modal.js"
import {onVisible} from "./helpers.js"

window.EmblaCarousel = EmblaCarousel;
window.onVisible = onVisible;
window.customConfirm = customConfirm;

// Livewire 3 ships its own Alpine and starts it. Register data factories
// and stores via the `alpine:init` event, which fires before Alpine.start().
// This script tag must be loaded BEFORE @livewireScripts.
document.addEventListener('alpine:init', () => {
    window.Alpine.data('accommodation', Accommodation);
    window.Alpine.store('confirmModal', ConfirmStore);
});